import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FooterCTA.css';

const FooterCTA = () => {
  const navigate = useNavigate();

  return (
    <section id="contact" className="footer-cta-section">
      <div className="footer-cta-container">
        <h2 className="footer-cta-title">Ready to Transform Your Talent Architecture?</h2>
        <p className="footer-cta-text">
          Take the Right 6™ Assessment or connect with our team to explore how we can support your growth.
        </p>
        <div className="footer-cta-buttons">
          <button className="btn btn-cta-primary" onClick={() => navigate('/assessment')}>Take the Assessment</button>
          <button className="btn btn-cta-secondary" onClick={() => window.open('https://form.jotform.com/260186646305054', '_blank')}>Get in Touch</button>
          <button className="btn btn-cta-secondary" onClick={() => window.open('https://form.jotform.com/260155110017036', '_blank')}>Become an Affiliate</button>
        </div>
      </div>
    </section>
  );
};

export default FooterCTA;